import { usageIds } from "../constants/usageid.js";
export var DomainSchemaIds;
(function (DomainSchemaIds) {
    DomainSchemaIds["DOMAIN"] = "domain";
})(DomainSchemaIds || (DomainSchemaIds = {}));
export var DomainTags;
(function (DomainTags) {
    DomainTags["AS_TEAM"] = "asTeam";
    DomainTags["AS_ACCOUNT"] = "asAccount";
})(DomainTags || (DomainTags = {}));
export const DomainTagsMap = {
    [DomainSchemaIds.DOMAIN]: [DomainTags.AS_TEAM, DomainTags.AS_ACCOUNT],
};
export const DomainUsageIds = usageIds(DomainTagsMap);
